import React from "react";
import "../../styles/components/GlobalSearch.css";
import GlobalFormModal from "./GlobalFormModal";

interface State {
  search: string;
  isOpen: boolean;
}

class GlobalSearch extends React.Component<Record<string, unknown>, State> {
  private buttonRef: React.RefObject<HTMLButtonElement>;

  constructor(props: Record<string, unknown>) {
    super(props);
    this.state = {
      search: "",
      isOpen: false,
    };
    this.buttonRef = React.createRef();
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount(): void {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount(): void {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown(event: KeyboardEvent): void {
    if ((event.ctrlKey || event.metaKey) && event.key === "k") {
      event.preventDefault();
      this.buttonRef.current?.click();
    } else if (event.key === "Escape") {
      this.handleClose();
    }
  }

  handleClick(): void {
    this.setState({ isOpen: true });
  }

  handleClose(): void {
    this.setState({ isOpen: false });
  }

  render(): JSX.Element {
    return (
      <>
        <button
          ref={this.buttonRef}
          className="search-button"
          onClick={this.handleClick}
        >
          <svg
            className="search-icon"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
              stroke="#8C8C8C"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14 14L11 11"
              stroke="#8C8C8C"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <div className="search-prompt">
            <kbd>Ctrl + K</kbd>
            <span>
              Search across customers, clients, redemptions, transfers and online transactions...
            </span>
          </div>
        </button>
        <GlobalFormModal
          isOpen={this.state.isOpen}
          onClose={this.handleClose}
        />
      </>
    );
  }
}

export default GlobalSearch;
